import React from 'react';

export interface IconCircleProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconCircle: React.FC<IconCircleProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M12 2C9.34781 2 6.80427 3.05357 4.9289 4.92893C3.05354 6.8043 1.99997 9.34784 1.99997 12C1.99997 14.6522 3.05354 17.1957 4.9289 19.0711C6.80427 20.9464 9.34781 22 12 22C14.6521 22 17.1957 20.9464 19.071 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.071 4.92893C17.1957 3.05357 14.6521 2 12 2V2Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />  
    </svg>
  );
};

export default IconCircle;
